var map = {
	"./mystery_box_lv1.png": 7576,
	"./mystery_box_lv10.png": 7550,
	"./mystery_box_lv2.png": 7499,
	"./mystery_box_lv3.png": 4165,
	"./mystery_box_lv4.png": 2887,
	"./mystery_box_lv5.png": 1339,
	"./mystery_box_lv6.png": 3485,
	"./mystery_box_lv7.png": 737,
	"./mystery_box_lv8.png": 6550,
	"./mystery_box_lv9.png": 6307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9510;